// @flow

import { combineReducers, type Action, type Reducer } from 'redux';

import { reducer as authenticationReducer } from '@gandi/authentication';
import {
  currenciesReducer as gandiReduxBillingCurrencies,
  infosReducer as gandiReduxBillingInfos,
  prepaidReducer as gandiReduxBillingPrepaid,
  pricingReducer as gandiReduxBillingPricing,
  type State as ReduxBillingState,
} from '@gandi/billing';
import { reducer as notificationsReducer } from '@gandi/notifications';
import { reducer as gandiReduxPlaces } from '@gandi/redux-places';
import { reducer as gandiReduxResource } from '@gandi/redux-resource';
import { reducer as sharingReducer } from '@gandi/redux-sharing';

import { csrfReducer, reducer as gandiFormReducer } from 'gandi.react-form';
import { reducer as layoutReducer } from 'gandi.react-public-layout';

import abuseReducer from './Abuse/modules';
import supportReducer from './Support/modules';
import statusReducer from './modules/status';
import unsubscriptionReducer from './Unsubscription/modules';

const gandiReduxBilling: Reducer<
  Partial<ReduxBillingState>,
  Action<any>
> = combineReducers({
  currencies: gandiReduxBillingCurrencies,
  infos: gandiReduxBillingInfos,
  prepaid: gandiReduxBillingPrepaid,
  pricing: gandiReduxBillingPricing,
});

export default {
  csrf: csrfReducer,
  authentication: authenticationReducer,
  layout: layoutReducer,
  notifications: notificationsReducer,
  sharing: sharingReducer,
  gandiForm: gandiFormReducer,
  gandiReduxBilling,
  gandiReduxPlaces,
  gandiReduxResource,
  support: supportReducer,
  abuse: abuseReducer,
  status: statusReducer,
  unsubscription: unsubscriptionReducer,
};
